import React from 'react'
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  TelegramIcon,
  RedditIcon,
  LinkedinIcon,
  EmailIcon
} from "react-share";
const NewCluster = () => {
  const shareurl = `${process.env.REACT_APP_CLIENT_URL}/internship`;
  return (
    <div style={{marginTop:"500px"}}>
      <FacebookShareButton url={shareurl}>
      <FacebookIcon size={20}/>
     </FacebookShareButton>

      <WhatsappShareButton url={shareurl}>
      <WhatsappIcon size={50}/>
     </WhatsappShareButton>

      <TwitterShareButton url={shareurl}>
      <TwitterIcon size={50}/>
     </TwitterShareButton>

      <TelegramShareButton url={shareurl}>
      <TelegramIcon size={50}/>
     </TelegramShareButton>

      <RedditShareButton url={shareurl}>
      <RedditIcon size={50}/>
     </RedditShareButton>

      <LinkedinShareButton url={shareurl}>
      <LinkedinIcon size={50}/>
     </LinkedinShareButton>

      <EmailShareButton url={shareurl}>
      <EmailIcon size={50}/>
     </EmailShareButton>
    </div>
  )
}

export default NewCluster